import type { ReactNode, SetStateAction, Dispatch, FC } from "react";
import { createContext, useState, useContext } from "react";

interface IShareOfVoiceContextType {
    includeOtherShareOfVoice: boolean;
    setIncludeOtherShareOfVoice: Dispatch<SetStateAction<boolean>>;
}

const ShareOfVoiceContext = createContext<IShareOfVoiceContextType | undefined>(undefined);

export const useShareOfVoice = () => {
    const context = useContext(ShareOfVoiceContext);
    if (context === undefined) {
        throw new Error("useShareOfVoice must be used within a ShareOfVoiceProvider");
    }
    return context;
};

interface IShareOfVoiceProviderProps {
    children: ReactNode;
    initialState?: boolean;
}

export const ShareOfVoiceProvider: FC<IShareOfVoiceProviderProps> = ({ children, initialState = false }) => {
    const [includeOtherShareOfVoice, setIncludeOtherShareOfVoice] = useState(initialState);

    const value = {
        includeOtherShareOfVoice,
        setIncludeOtherShareOfVoice,
    };

    return <ShareOfVoiceContext.Provider value={value}>{children}</ShareOfVoiceContext.Provider>;
};
